// Copyright (c) 2017 Deere & Company

import ReimbursementSummaryClaimSummaryData from '../state/claim-summary';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateClaimSummary = (state, action) =>
    ReimbursementSummaryClaimSummaryData.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().data, action) => {

    const actionTypes = {
        [actions.READ_CLAIM_SUMMARY_SUCCESS]: updateClaimSummary
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reimbursement-summary/claims/reducers/claim-summary.js